import type { MutableRefObject } from "react";
import { ReasonForm } from "./ReasonForm";

const localeRoot = "community_onboarding.new_checklist.paywall_survey_modal";

const reasonKeys = [
  "free_community",
  "included_with_something",
  "use_another_platform",
  "setup_later",
  "other",
];

interface PaywallSurveyFormProps {
  onSubmit: () => void;
  triggerFormSubmitRef?: MutableRefObject<(() => Promise<void>) | null>;
}

export const PaywallSurveyForm = ({
  onSubmit,
  triggerFormSubmitRef,
}: PaywallSurveyFormProps) => (
  <ReasonForm
    eventType="checklist.paywall_survey.reason.submitted"
    localeRoot={localeRoot}
    reasonKeys={reasonKeys}
    onSubmit={onSubmit}
    triggerFormSubmitRef={triggerFormSubmitRef}
  />
);
